import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=6b999fe2"
import script from "./CatalogItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogItem.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports